import { type FeatureFlagType, isEnabledFeature } from './types';

interface FeatureFlagProps {
  flag: FeatureFlagType;
  children: React.ReactNode;
}

export const FeatureFlag = ({ flag, children }: FeatureFlagProps) =>
  isEnabledFeature(flag) ? children : null;

// サーバーサイドの機能フラグコンポーネントをエクスポート
export { ServerFeatureFlag } from './server-feature-flag';
